import { Controller } from "@hotwired/stimulus";

/**
 * Controller for calendar export that handles iOS PWA limitations.
 *
 * iOS PWA standalone mode cannot download .ics files directly.
 * Workaround: Navigate to the URL which opens Safari, where the download works.
 */
export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    // Pre-calculate if we're in iOS PWA mode for better performance
    this.isIOSPWA = this.detectIOSPWA();
  }

  /**
   * Detect if running as PWA on iOS (standalone mode)
   */
  detectIOSPWA() {
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
                      || window.navigator.standalone === true;

    return isIOS && isStandalone;
  }

  /**
   * Handle calendar export click
   * - iOS PWA: Open in Safari (breaks out of PWA) where .ics download works
   * - Everything else: Use normal .ics download link
   */
  export(event) {
    if (this.isIOSPWA) {
      event.preventDefault();

      // Open the URL in Safari by using window.open with _self
      // This breaks out of the PWA and opens Safari where .ics downloads work
      window.location.href = this.urlValue;
    }
    // For non-iOS-PWA: let the default link behavior happen (normal .ics download)
  }
}
